import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Work from './components/Work';
import Leadership from './components/Leadership';
import Projects from './components/Projects';
import Contact from './components/Contact';
import ParticleBackground from './components/ParticleBackground';
import FloatingSphere from './components/FloatingSphere';
import ScrollToTop from './components/ScrollToTop';
import ParallaxSection from './components/ParallaxSection';

function App() {
  return (
    <>
      <ScrollToTop />
      {/* Global shell: premium dark-first canvas with layered motion backgrounds */}
      <div className="App relative min-h-screen overflow-x-hidden bg-cosmic-aurora text-slate-100">
        <FloatingSphere />
        <ParticleBackground />

        <Navbar />

        <AnimatePresence mode="wait">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
            className="relative z-10"
          >
            <Hero />
            <ParallaxSection speed={0.12}>
              <About />
            </ParallaxSection>
            <ParallaxSection speed={0.16}>
              <Work />
            </ParallaxSection>
            <ParallaxSection speed={0.14}>
              <Leadership />
            </ParallaxSection>
            <ParallaxSection speed={0.18}>
              <Projects />
            </ParallaxSection>
            <ParallaxSection speed={0.1}>
              <Contact />
            </ParallaxSection>
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
}

export default App;
